<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>新网账户管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          @click="$router.push('/balanceAdd')"
          class="btn"
          >添加账户</el-button
        >
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          ref="multipleTable"
        >
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="账户名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.accountName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="账户号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.pendingAccts }}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span class="redColor" v-if="scope.row.xwbankStatus == 0"
                >未开户</span
              >
              <span class="greenColor" v-if="scope.row.xwbankStatus == 1"
                >开户成功</span
              >
              <span class="redColor" v-if="scope.row.xwbankStatus == 2"
                >开户失败</span
              >
              <span class="blueColor" v-if="scope.row.xwbankStatus == 3"
                >审核中</span
              >
            </template>
          </el-table-column>
          <el-table-column label="账户说明" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.accountDesc }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <div>
                  <div class="operateBtn" @click="goDetail(scope.row)">
                    查看详情
                  </div>
                </div>
                <div
                  style="margin-left: 20px"
                  v-if="scope.row.xwbankStatus == 3"
                >
                  <div class="operateBtn" @click="select(scope.row)">
                    开户验证
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="开户验证" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item
          label="小额打款验证"
          prop="name"
          v-if="selectData.verifyCompletedStatus == 2"
        >
          <el-input
            v-model="ruleForm1.money"
            placeholder="请输入打款金额"
          ></el-input>
          <el-button
            v-loading="loading"
            type="primary"
            @click="submitForm()"
            style="margin-left: 30px"
            >提交</el-button
          >
        </el-form-item>
        <el-form-item
          label="联系人开户短信验证码"
          prop="num"
          v-if="selectData.verifyCompletedStatus == 3"
        >
          <el-input
            v-model="ruleForm1.code"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            type="primary"
            @click="getCode()"
            style="margin-left: 30px"
            v-loading="loading1"
            >获取验证码</el-button
          >
          <el-button
            type="primary"
            @click="submitCode()"
            style="margin-left: 30px"
            v-loading="loading"
            >提交</el-button
          >
        </el-form-item>
        <el-form-item
          label="法人开户短信验证码"
          prop="num"
          v-if="
            selectData.verifyCompletedStatus == 3 &&
            selectData.phone !== selectData.contactInformation
          "
        >
          <el-input
            v-model="ruleForm1.code1"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            type="primary"
            @click="getCode1()"
            style="margin-left: 30px"
            v-loading="loading1"
            >获取验证码</el-button
          >
          <el-button
            type="primary"
            @click="submitCode1()"
            style="margin-left: 30px"
            v-loading="loading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      tableData: [],
      dialogFormVisible: false,
      ruleForm1: {
        money: "",
        code: "",
        code1: "",
      },
      selectData: {},
      loading: false,
      loading1: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goDetail(row) {
      this.$router.push({
        path: "/balanceAdd",
        query: { id: row.id },
      });
    },
    select(row) {
      this.selectData = row;
      this.dialogFormVisible = true;
    },
    submitForm() {
      this.loading = true;
      this.$axios
        .post(`/admapi/innerAccount/smallAmountPayment`, {
          customId: this.selectData.id,
          verifyAmt: this.ruleForm1.money,
          openacctNo: this.selectData.openacctNo,
          customNo: this.selectData.platformCustomerNo,
          verifyBizNo: "OPEN_ACCT",
        })
        .then(({ data }) => {
          this.$message({
            message: "小额打款验证成功",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.getList();
        })
        .catch((this.loading = false))
        .finally();
    },
    submitCode() {
      this.loading = true;
      this.$axios
        .post(`/admapi/innerAccount/openAccountSmsConfirm`, {
          customId: this.selectData.id,
          messageCaptcha: this.ruleForm1.code,
          messageType: "OPEN_ACCT_SMS_CONTACT_AUTH",
          openacctNo: this.selectData.openacctNo,
          customNo: this.selectData.platformCustomerNo,
        })
        .then(({ data }) => {
          this.$message({
            message: "联系人开户短信验证成功",
            type: "success",
          });
          // this.dialogFormVisible = false;
          this.getList();
        })
        .catch()
        .finally((this.loading = false));
    },
    submitCode1() {
      this.loading = true;
      this.$axios
        .post(`/admapi/innerAccount/openAccountSmsConfirm`, {
          customId: this.selectData.id,
          messageCaptcha: this.ruleForm1.code1,
          messageType: "OPEN_ACCT_SMS_LEGAL_AUTH",
          openacctNo: this.selectData.openacctNo,
          customNo: this.selectData.platformCustomerNo,
        })
        .then(({ data }) => {
          this.$message({
            message: "法人开户短信验证成功",
            type: "success",
          });
          // this.dialogFormVisible = false;
          this.getList();
        })
        .catch()
        .finally((this.loading = false));
    },
    //获取联系人手机号验证码
    getCode() {
      this.loading1 = true;
      this.$axios
        .post(`/admapi/innerAccount/sendVerifySMS`, {
          messageType: "OPEN_ACCT_SMS_CONTACT_AUTH",
          phone: this.selectData.phone,
          openacctNo: this.selectData.openacctNo,
          customNo: this.selectData.platformCustomerNo,
        })
        .then(({ data }) => {
          this.$message({
            message: "验证码发送成功",
            type: "success",
          });
        })
        .catch()
        .finally((this.loading1 = false));
    },
    //获取法人手机号验证码
    getCode1() {
      this.loading1 = true;
      this.$axios
        .post(`/admapi/innerAccount/sendVerifySMS`, {
          messageType: "OPEN_ACCT_SMS_LEGAL_AUTH",
          phone: this.selectData.contactInformation,
          openacctNo: this.selectData.openacctNo,
          customNo: this.selectData.platformCustomerNo,
        })
        .then(({ data }) => {
          this.$message({
            message: "验证码发送成功",
            type: "success",
          });
        })
        .catch()
        .finally((this.loading1 = false));
    },
    getList() {
      this.$axios
        .post(`/admapi/innerAccount/getInnerAccountList`)
        .then(({ data }) => {
          this.tableData = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
